import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Home from './pages/Home/Home'
import Investor from './pages/Investor'
import AnnualReport from './pages/AnnualReport/AnnualReport'
import FinancialReport from './pages/FinancialReport/FinancialReport'
import RUPS from './pages/RUPS/RUPS'
import CorporateAction from './pages/CorporateAction/CorporateAction'
import ShareHolder from './pages/ShareHolder/ShareHolder'
import Dividen from './pages/Dividen/Dividen'
import Obligation from './pages/Obligation/Obligation'
import Prospectus from './pages/Prospectus/Prospectus'
import PublicExpose from './pages/PublicExpose/PublicExpose'
import AnalytistMeeting from './pages/AnalytistMeeting/AnalytistMeeting'
import Agenda from './pages/Agenda'
import ContactUs from './pages/ContactUs/ContactUs'
import NewUpdates from './pages/NewUpdates/NewUpdates'
import Container from './pages/CurrencyInfo/CurrencyInfo'
import SBDK from './pages/SBDK/SBDK'
import NewsRoom from './pages/NewsRoom/NewsRoom'
import PressConference from './pages/PressConference/PressConference'
import Announcement from './pages/Announcement/Announcement'
import ArticleDetail from './pages/ArticleDetail'
import ArticleDetail2 from './pages/ArticleDetail2'
import ArticleDetail3 from './pages/ArticleDetail3'

import DebitCard from './pages/DailySolution/DebitCard/DebitCard'
import DebitCardDetail from './pages/DailySolution/DebitCardDetail/DebitCardDetail'
import CreditCard from './pages/DailySolution/CreditCard/CreditCard'
import CreditCardDetail from './pages/DailySolution/CreditCardDetail/CreditCardDetail'
import BukopinPriority from './pages/DailySolution/BukopinPriority/BukopinPriority'
import SavingsDetail from './pages/FutureSolution/SavingsDetail/SavingsDetail'
import Savings from './pages/FutureSolution/Savings/Savings'
import LoanList from './pages/FutureSolution/LoanList/LoanList'
import LoanDetail from './pages/FutureSolution/LoanDetail/LoanDetail'
import WealthManagement from './pages/FutureSolution/WealthManagement/WealthManagement'
import WealthManagementDetail from './pages/FutureSolution/WealthManagementDetail/WealthManagementDetail'
import TentangCorporateGovernance from './pages/CorporateGovernance/TentangCorporateGovernance/TentangCorporateGovernance'
import PedomanCorporateGovernance from './pages/CorporateGovernance/PedomanCorporateGovernance/PedomanCorporateGovernance'
import WhistleBlowingCorporateGovernance from './pages/CorporateGovernance/WhistleBlowingCorporateGovernance/WhistleBlowingCorporateGovernance'
import KodeEtikCorporateGovernance from './pages/CorporateGovernance/KodeEtikCorporateGovernance/KodeEtikCorporateGovernance'
import LaporanCorporateGovernance from './pages/CorporateGovernance/LaporanCorporateGovernance/LaporanCorporateGovernance'
import ListBusinessSolution from './pages/BusinessSolution/ListBusinessSolution/ListBusinessSolution'
import DetailBusinessSolution from './pages/BusinessSolution/DetailBusinessSolution/DetailBusinessSolution'
import ListStructureCorporate from './pages/StructureCorporate/ListStructureCorporate/ListStructureCorporate'
import PolicySocialResponsibiltiy from './pages/SocialResponsibiltiy/PolicySocialResponsibiltiy/PolicySocialResponsibiltiy'
import HistoryProfile from './pages/ProfileBukopin/History/HistoryProfile'
import AwardProfile from './pages/ProfileBukopin/Award/AwardProfile'
import KorespondenProfile from './pages/ProfileBukopin/Koresponden/KorespondenProfile'
import InstituteProfile from './pages/ProfileBukopin/Institute/InstituteProfile'
import ContactUsProfile from './pages/ProfileBukopin/Contact/ContactUsProfile'
import ListNetwork from './pages/Network/ListNetwork/ListNetwork'
import BestServiceList from './pages/BestService/BestServiceList/BestServiceList'
import IndividuDetail from './pages/BestService/IndividuDetail/IndividuDetail'
import BisnisDetail from './pages/BestService/BisnisDetail/BisnisDetail'
import PolicySocialActivity from './pages/SocialResponsibiltiy/PolicySocialActivity/PolicySocialActivity'
import WorkCareer from './pages/Career/WorkCareer/WorkCareer'
import ListInspiration from './pages/Inspiration/ListInspiration/ListInspiration'
import ListInspirationDetail from './pages/Inspiration/ListInspiration/ListInspirationDetail'
import SupportCenter from './pages/CustomerService/SupportCenter/SupportCenter'
import TransactionService from './pages/CustomerService/TransactionService/TransactionService'
import JobsCareer from './pages/Career/JobsCareer/JobsCareer'
import PiagamCorporateGovernance from './pages/CorporateGovernance/PiagamCorporateGovernance/PiagamCorporateGovernance'

import ScrollToTop from './services/ScrollToTop'
import Promotion from './pages/Promotion/Promotion'
import PromotionDetail from './pages/Promotion/PromotionDetail'
import Search from './pages/Search/Search'
import PrivacyAnnouncementGovernance from './pages/CorporateGovernance/PrivacyAnnouncementGovernance/PrivacyAnnouncement.jsx'

const createRoutes = () => (
  <Router>
    <ScrollToTop>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/investor">
          <Investor />
        </Route>
        <Route exact path="/annual-report">
          <AnnualReport />
        </Route>
        <Route exact path="/financial-report">
          <FinancialReport />
        </Route>
        <Route exact path="/rups">
          <RUPS />
        </Route>
        <Route exact path="/corporate-action">
          <CorporateAction />
        </Route>
        <Route exact path="/share-holders">
          <ShareHolder />
        </Route>
        <Route exact path="/dividen">
          <Dividen />
        </Route>
        <Route exact path="/obligation">
          <Obligation />
        </Route>
        <Route exact path="/prospectus">
          <Prospectus />
        </Route>
        <Route exact path="/public-expose">
          <PublicExpose />
        </Route>
        <Route exact path="/analyst-meeting">
          <AnalytistMeeting />
        </Route>
        <Route exact path="/agenda">
          <Agenda />
        </Route>
        <Route exact path="/contact-us">
          <ContactUs />
        </Route>
        <Route exact path="/info-terbaru">
          <NewUpdates />
        </Route>
        <Route exact path="/currency-info">
          <Container />
        </Route>
        <Route exact path="/sbdk">
          <SBDK />
        </Route>
        <Route exact path="/news">
          <NewsRoom />
        </Route>
        <Route exact path="/press-conference">
          <PressConference />
        </Route>
        <Route exact path="/announcement">
          <Announcement />
        </Route>
        <Route exact path="/article-detail/:slug">
          <ArticleDetail />
        </Route>
        <Route exact path="/article-detail2/:slug">
          <ArticleDetail2 />
        </Route>
        <Route exact path="/article-detail3/:slug">
          <ArticleDetail3 />
        </Route>
        {/* Daily Solution */}
        <Route exact path="/debit-card">
          <DebitCard />
        </Route>
        <Route exact path="/debit-card/:id">
          <DebitCardDetail />
        </Route>
        <Route exact path="/credit-card">
          <CreditCard />
        </Route>
        <Route exact path="/credit-card/:id">
          <CreditCardDetail />
        </Route>
        <Route exact path="/bukopin-priority">
          <BukopinPriority />
        </Route>
        {/* Future Solution */}
        <Route exact path="/savings/:id">
          <SavingsDetail />
        </Route>
        <Route exact path="/savings/">
          <Savings />
        </Route>
        <Route exact path="/loan/">
          <LoanList />
        </Route>
        <Route exact path="/loan/:id">
          <LoanDetail />
        </Route>
        <Route exact path="/wealth-management/">
          <WealthManagement />
        </Route>
        <Route exact path="/wealth-management/:id">
          <WealthManagementDetail />
        </Route>
        {/* tata-kelola-perusahaan */}
        <Route exact path="/corporate-governance/about">
          <TentangCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/guidelines">
          <PedomanCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/report">
          <LaporanCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/code-of-ethics">
          <KodeEtikCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/whistleblowing-system">
          <WhistleBlowingCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/piagam">
          <PiagamCorporateGovernance />
        </Route>
        <Route exact path="/corporate-governance/privacy-notice">
          <PrivacyAnnouncementGovernance />
        </Route>

        {/* businessSolution */}
        <Route exact path="/business-solution/:id">
          <ListBusinessSolution />
        </Route>
        <Route exact path="/business-solution/detail/:id">
          <DetailBusinessSolution />
        </Route>

        {/* Structure Corporate */}
        <Route exact path="/structure-corporate/:id">
          <ListStructureCorporate />
        </Route>
        <Route exact path="/structure-corporate/detail/:id">
          <DetailBusinessSolution />
        </Route>

        {/* about */}

        {/* csr-policy */}
        <Route exact path="/csr-policy">
          <PolicySocialResponsibiltiy />
        </Route>

        <Route exact path="/profile/award">
          <AwardProfile />
        </Route>
        <Route exact path="/profile/correspondent-bank">
          <KorespondenProfile />
        </Route>
        <Route exact path="/profile/institute-bank">
          <InstituteProfile />
        </Route>
        <Route exact path="/profile/contact-us">
          <ContactUsProfile />
        </Route>

        <Route exact path="/profile/:id">
          <HistoryProfile />
        </Route>
        {/* Network */}
        <Route exact path="/network/kantor">
          <ListNetwork item="kantor" />
        </Route>
        <Route exact path="/network/atm">
          <ListNetwork item="atm" />
        </Route>
        <Route exact path="/csr-activity">
          <PolicySocialActivity />
        </Route>

        {/* best service */}
        <Route exact path="/individu-service">
          <BestServiceList props={{ id: 'individu' }} />
        </Route>
        <Route exact path="/individu-service/:id">
          <IndividuDetail />
        </Route>
        <Route exact path="/bisnis-service">
          <BestServiceList props={{ id: 'bisnis' }} />
        </Route>
        <Route exact path="/bisnis-service/:id">
          <BisnisDetail />
        </Route>

        {/* career */}
        <Route exact path="/career-work">
          <WorkCareer />
        </Route>
        <Route exact path="/career-jobs">
          <JobsCareer />
        </Route>

        {/* inspiration */}
        <Route exact path="/inspiration/artikel/:slug">
          <ListInspirationDetail />
        </Route>
        <Route exact path="/inspiration">
          <ListInspiration />
        </Route>

        <Route exact path="/support-center">
          <SupportCenter />
        </Route>

        <Route exact path="/transaction-service">
          <TransactionService />
        </Route>

        <Route exact path="/promotion">
          <Promotion />
        </Route>

        <Route exact path="/promotion/detail/:id">
          <PromotionDetail />
        </Route>

        {/* search */}
        <Route exact path="/search">
          <Search />
        </Route>
      </Switch>
    </ScrollToTop>
  </Router>
)

export default createRoutes
